exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/~/core-js/modules/_wks-ext.js
// module id = ../../../../core-js/modules/_wks-ext.js
// module chunks = 3